import SignInComponent from "../components/signIn/SignInComponent";
import SignInLoginComponent from "../components/signIn/SignInLoginComponent";

const SignInPage = () => {
	// return <SignInComponent />;
	return <SignInLoginComponent />;
};

export default SignInPage;
